import { Fragment, useState, useEffect } from "react";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import LockIcon from "@mui/icons-material/Lock";
import ShieldIcon from "@mui/icons-material/Shield";
import TaskIcon from "@mui/icons-material/Task";
import { Avatar, Divider, List, Collapse, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Logout } from "./Logout";
import { NavLink } from "./NavLink";
import * as S from "./styles";
import { ReactComponent as Logo } from "~/assets/images/jawla-logo.svg";
import { ROUTE_PATHS } from "~/constants/routes";
import { UserState } from "~/store/user/types";
// import { ls } from "~/utils/localStorage";

interface SidebarProps {
  widthChanged: (value: boolean) => void;
}

const Sidebar = ({ widthChanged }: SidebarProps) => {
  const [open, setOpen] = useState(true);
  const [openSubMenu, setOpenSubMenu] = useState<any>(-1);
  const [openCollapse, setOpenCollapse] = useState(false);
  const { data } = useSelector<any, UserState>((state) => state.user);


  const stringToColor = (string: string) => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  };
  const stringAvatar = (name: string) => ({
    sx: {
      bgcolor: stringToColor(name),
      width: "24px",
      height: "24px",
      border: "1px solid white",
    },
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  });

  const storedDepartment = localStorage.getItem("department");

  // Check if storedDepartment is not null before parsing
  const parsedDepartment = storedDepartment
    ? JSON.parse(storedDepartment)
    : null;

  const role = localStorage.getItem("role");
  const sections: any[] = [
    {
      links: [
        {
          label: `${data?.first_name} ${data?.last_name}`,
          href: "",
          icon: (
            <Avatar
              {...stringAvatar(`${data?.first_name} ${data?.last_name}`)}
            />
          ),
          subLinks: [
            {
              label: "Profile",
              href: ROUTE_PATHS.PROFILE,
              icon: <AccountCircleIcon />,
            },
          ],
        },
        {
          label: "Dashboard",
          href: ROUTE_PATHS.DASHBOARD,
          icon: <DashboardIcon />,
        },
        // ...(user.can_create_leads === 1
        //   ? [
        //       {
        //         label: "Customer list",
        //         href: ROUTE_PATHS.CUSTOMERS_LIST,
        //         icon: <GroupIcon />,
        //       },
        //     ]
        //   : []),
      ],
    },
  ];
    // Add Reports tab for all users
    const reportsObject = {
      label: "Reports",
      href: "",
      icon: <AssignmentReturnIcon />,
      subLinks: [
        {
          label: "Requests Count",
          href: ROUTE_PATHS.REPORTS_REQUESTS_COUNT,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Sales Report",
          href: ROUTE_PATHS.REPORTS_SALES,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    sections[0].links.push(reportsObject);
  if (
    (parsedDepartment && parsedDepartment.name === "HR") ||
    role === "admin"
  ) {
    // Create the HR-specific object
    const hrObject = {
      label: "HR",
      href: "",
      icon: <GroupIcon />,
      subLinks: [
        {
          label: "Users",
          href: ROUTE_PATHS.USERS,
          icon: <GroupIcon />,
        },
        {
          label: "Departments",
          href: ROUTE_PATHS.DEPARTMENT,
          icon: <AccountTreeIcon />,
        },
        {
          label: "Roles",
          href: ROUTE_PATHS.ROLES,
          icon: <ShieldIcon />,
        },
        {
          label: "Permissions",
          href: ROUTE_PATHS.PERMISSIONS,
          icon: <LockIcon />,
        },
        {
          label: "Holidays",
          href: ROUTE_PATHS.HOLIDAAYS,
          icon: <TaskIcon />,
        },
      ],
    };

    sections[0].links.push(hrObject);
  }
  if (
    (parsedDepartment && parsedDepartment.name === "Sales") ||
    role === "admin"
  ) {
    // Create the HR-specific object
    const salesAdminObject = {
      label: "Sales",
      href: "",
      icon: <ContactPhoneIcon />,
      subLinks: [
        {
          label: "Fresh Requests",
          href: ROUTE_PATHS.SALES_FRESH_REQUESTS_LIST,
          icon: <AssignmentReturnIcon />,
        },
        // {
        //   label: "Assigned Requests",
        //   href: ROUTE_PATHS.SALES_ASSIGNED_REQUESTS_LIST,
        //   icon: <AssignmentReturnIcon />,
        // },
        {
          label: "My Requests",
          href: ROUTE_PATHS.SALES_MY_REQUESTS_LIST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Summary Requests",
          href: ROUTE_PATHS.SALES_SUMMARY_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Confirmed ",
          href: ROUTE_PATHS.SALES_CONFIRMED_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Cancellation ",
          href: ROUTE_PATHS.SALES_CANCELED_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Paid Payment ",
          href: ROUTE_PATHS.SALES_PAID_PAYMENT_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Follow Up",
          href: ROUTE_PATHS.SALES_FOLLOWUP_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };

    const salesDepartmentMangerObject = {
      label: "Sales",
      href: "",
      icon: <ContactPhoneIcon />,
      subLinks: [
        {
          label: "Fresh Requests",
          href: ROUTE_PATHS.SALES_FRESH_REQUESTS_LIST,
          icon: <AssignmentReturnIcon />,
        },
        // {
        //   label: "Assigned Requests",
        //   href: ROUTE_PATHS.SALES_ASSIGNED_REQUESTS_LIST,
        //   icon: <AssignmentReturnIcon />,
        // },
        {
          label: "Permissions",
          href: ROUTE_PATHS.PERMISSIONS,
          icon: <LockIcon />,
        },
        {
          label: "Holidays",
          href: ROUTE_PATHS.HOLIDAAYS,
          icon: <TaskIcon />,
        },
        {
          label: "My Requests",
          href: ROUTE_PATHS.SALES_MY_REQUESTS_LIST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Summary Requests",
          href: ROUTE_PATHS.SALES_SUMMARY_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Confirmed ",
          href: ROUTE_PATHS.SALES_CONFIRMED_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Cancellation ",
          href: ROUTE_PATHS.SALES_CANCELED_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Paid Payment ",
          href: ROUTE_PATHS.SALES_PAID_PAYMENT_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Follow up Requests",
          href: ROUTE_PATHS.SALES_FOLLOWUP_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    if (role === "admin" || role === "user") {
      sections[0].links.push(salesAdminObject);
    }
    if (role === "department_manager") {
      sections[0].links.push(salesDepartmentMangerObject);
    }
  }
  if (
    (parsedDepartment && parsedDepartment.name === "Call Center") ||
    role === "admin"
  ) {
    // Create the HR-specific object
    const callCenterAdminObject = {
      label: "Call center",
      href: "",
      icon: <ContactPhoneIcon />,
      subLinks: [
        // {
        //   label: "Customer list",
        //   href: ROUTE_PATHS.CUSTOMERS_LIST,
        //   icon: <GroupIcon />,
        // },
        {
          label: "All Requests",
          href: ROUTE_PATHS.CALL_CENTER_ALLREQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Summary Requests",
          href: ROUTE_PATHS.CALLCENTER_SUMMARY_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    const callCenterDepartmentMangerObject = {
      label: "Call center",
      href: "",
      icon: <ContactPhoneIcon />,
      subLinks: [
        // {
        //   label: "Customer list",
        //   href: ROUTE_PATHS.CUSTOMERS_LIST,
        //   icon: <GroupIcon />,
        // },
        {
          label: "All Requests",
          href: ROUTE_PATHS.CALL_CENTER_ALLREQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Summary Requests",
          href: ROUTE_PATHS.CALLCENTER_SUMMARY_REQUEST,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Permissions",
          href: ROUTE_PATHS.PERMISSIONS,
          icon: <LockIcon />,
        },
        {
          label: "Holidays",
          href: ROUTE_PATHS.HOLIDAAYS,
          icon: <TaskIcon />,
        },
      ],
    };

    if (role === "admin" || role === "user") {
      sections[0].links.push(callCenterAdminObject);
    }
    if (role === "department_manager") {
      sections[0].links.push(callCenterDepartmentMangerObject);
    }
  }
  if (
    (parsedDepartment && parsedDepartment.name === "Accounting") ||
    role === "admin"
  ) {
    const accountingAdminObject = {
      label: "Accountants",
      href: "",
      icon: <GroupIcon />,
      subLinks: [
        {
          label: "Suppliers",
          href: ROUTE_PATHS.SUPPLIERS,
          icon: <GroupIcon />,
        },
        {
          label: "Fresh Requests",
          href: ROUTE_PATHS.ACCOUNTENT_FRESH,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Finished  ",
          href: ROUTE_PATHS.ACCOUNTENT_DONE,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "My Requests",
          href: ROUTE_PATHS.ACCOUNTENT_MYREQUESTS,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Assigned Requests",
          href: ROUTE_PATHS.ACCOUNTENT_ASSIGNED,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    const accountingDepartmentMangerObject = {
      label: "Accountants",
      href: "",
      icon: <GroupIcon />,
      subLinks: [
        {
          label: "Suppliers",
          href: ROUTE_PATHS.SUPPLIERS,
          icon: <GroupIcon />,
        },
        {
          label: "Fresh Requests",
          href: ROUTE_PATHS.ACCOUNTENT_FRESH,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Finished  ",
          href: ROUTE_PATHS.ACCOUNTENT_DONE,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Permissions",
          href: ROUTE_PATHS.PERMISSIONS,
          icon: <LockIcon />,
        },
        {
          label: "Holidays",
          href: ROUTE_PATHS.HOLIDAAYS,
          icon: <TaskIcon />,
        },
        {
          label: "My Requests",
          href: ROUTE_PATHS.ACCOUNTENT_MYREQUESTS,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Assigned Requests",
          href: ROUTE_PATHS.ACCOUNTENT_ASSIGNED,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    if (role === "admin" || role === "user") {
      sections[0].links.push(accountingAdminObject);
    }
    if (role === "department_manager") {
      sections[0].links.push(accountingDepartmentMangerObject);
    }
  }
  if (
    (parsedDepartment && parsedDepartment.name === "Audit") ||
    role === "admin"
  ) {
    const AuditAdminObject = {
      label: "Audit",
      href: "",
      icon: <ContactPhoneIcon />,
      subLinks: [
        {
          label: "Fresh Requests",
          href: ROUTE_PATHS.AUDIT_FRESH,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Rating Factors",
          href: ROUTE_PATHS.RATINGFACTOR,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "My Requests",
          href: ROUTE_PATHS.AUDIT_MYREQUESTS,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Assigned Requests",
          href: ROUTE_PATHS.AUDIT_ASSIGNED_REQUESTS_LIST,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    const AuditDepartmentMangerObject = {
      label: "Audit",
      href: "",
      icon: <ContactPhoneIcon />,
      subLinks: [
        {
          label: "Fresh Requests",
          href: ROUTE_PATHS.AUDIT_FRESH,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Rating Factors",
          href: ROUTE_PATHS.RATINGFACTOR,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Permissions",
          href: ROUTE_PATHS.PERMISSIONS,
          icon: <LockIcon />,
        },
        {
          label: "Holidays",
          href: ROUTE_PATHS.HOLIDAAYS,
          icon: <TaskIcon />,
        },
        {
          label: "My Requests",
          href: ROUTE_PATHS.AUDIT_MYREQUESTS,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Assigned Requests",
          href: ROUTE_PATHS.AUDIT_ASSIGNED_REQUESTS_LIST,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    if (role === "admin" || role === "user") {
      sections[0].links.push(AuditAdminObject);
    }
    if (role === "department_manager") {
      sections[0].links.push(AuditDepartmentMangerObject);
    }
  }
  if (
    (parsedDepartment && parsedDepartment.name === "Operation") ||
    role === "admin"
  ) {
    const OperationAdminObject = {
      label: "Operation",
      href: "",
      icon: <ContactPhoneIcon />,
      subLinks: [
        {
          label: "Fresh Requests ",
          href: ROUTE_PATHS.OPERATION_CONFIRMED_FRESH,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "My Requests",
          href: ROUTE_PATHS.OPERATION_MYREQUSTS,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Assigned Requests",
          href: ROUTE_PATHS.OPERATION_CONFIRMED_ASSIGNED,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    const OperationDepartmentMangerObject = {
      label: "Operation",
      href: "",
      icon: <ContactPhoneIcon />,
      subLinks: [
        {
          label: "Permissions",
          href: ROUTE_PATHS.PERMISSIONS,
          icon: <LockIcon />,
        },
        {
          label: "Holidays",
          href: ROUTE_PATHS.HOLIDAAYS,
          icon: <TaskIcon />,
        },
        {
          label: "Fresh Requests ",
          href: ROUTE_PATHS.OPERATION_CONFIRMED_FRESH,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "My Requests",
          href: ROUTE_PATHS.OPERATION_MYREQUSTS,
          icon: <AssignmentReturnIcon />,
        },
        {
          label: "Assigned Requests",
          href: ROUTE_PATHS.OPERATION_CONFIRMED_ASSIGNED,
          icon: <AssignmentReturnIcon />,
        },
      ],
    };
    if (role === "admin" || role === "user") {
      sections[0].links.push(OperationAdminObject);
    }
    if (role === "department_manager") {
      sections[0].links.push(OperationDepartmentMangerObject);
    }
  }
  const links = sections.map((section: any) => section.links);
  const flattenLinks = links.flat();

  const findIndex = flattenLinks.findIndex(
    (link: any) =>
      link.href === "" &&
      link.subLinks
        ?.map((subLink: any) => subLink.href)
        .includes(window.location.pathname)
  );

  useEffect(() => {
    setOpenSubMenu(findIndex);
  }, [findIndex, window.location.pathname]);

  const toggleDrawer = () => {
    setOpen(!open);
    widthChanged(!open);
  };

  const handleClick = (index: number) => {
    setOpenSubMenu(index === openSubMenu ? -1 : index);
  };

  const getDesktopSidebar = () => (
    <S.Drawer variant="permanent" open={open}>
      <S.ToggleContainer open={open}>
        {open && (
          <S.LogoContainer>
            <Logo />
          </S.LogoContainer>
        )}
        <S.ToggleIcon onClick={toggleDrawer}>
          {open ? <ArrowBack /> : <ArrowForward />}
        </S.ToggleIcon>
      </S.ToggleContainer>
      <Divider />
      <List
        component="nav"
        sx={{ bgcolor: "background.paper" }}
        aria-labelledby="nested-list-subheader"
      >
        {sections.map((section: any, index: number) => (
          <div key={`section-${index}`}>
            {section.links.map((link: any, key: number) => (
              <div key={`${key}-link`}>
                {!link.subLinks ? (
                  <NavLink
                    drawerOpen={open}
                    icon={link.icon}
                    key={link?.href}
                    href={link?.href || "#"}
                    hasSubMenu={false}
                  >
                    {link.label}
                  </NavLink>
                ) : (
                  <>
                    <NavLink
                      key={`${key}-subLink`}
                      hasSubMenu
                      drawerOpen={open}
                      icon={link.icon}
                      href="#"
                      openSubMenu={openSubMenu}
                      handleClick={() => handleClick(key)}
                      subMenuKey={key}
                    >
                      {link.label}
                    </NavLink>
                    <Collapse
                      in={openSubMenu === key}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        {link.subLinks?.map(
                          (subLink: any, keyIndex: number) => (
                            <Box
                              sx={{ marginLeft: "1.5rem" }}
                              key={`${keyIndex}-subLinkNav`}
                            >
                              <NavLink
                                drawerOpen
                                icon={subLink.icon}
                                key={subLink.href}
                                href={subLink.href}
                                hasSubMenu={subLink?.subLinks?.length > 0}
                                onClick={() => {
                                  setOpenCollapse(!openCollapse);
                                }}
                              >
                                {subLink.label}
                              </NavLink>
                              <Collapse in={openSubMenu === key} timeout="auto">
                                {openCollapse && (
                                  <List
                                    component="div"
                                    disablePadding
                                    sx={{ paddingLeft: "2rem" }}
                                  >
                                    {subLink?.subLinks?.map((test: any) => (
                                      <NavLink
                                        drawerOpen={openCollapse}
                                        icon={test.icon}
                                        key={test.href}
                                        href={test.href}
                                        hasSubMenu={false}
                                        onClick={() => setOpenCollapse(true)}
                                      >
                                        {test.label}
                                      </NavLink>
                                    ))}
                                  </List>
                                )}
                              </Collapse>
                            </Box>
                          )
                        )}
                      </List>
                    </Collapse>
                  </>
                )}
              </div>
            ))}
          </div>
        ))}
      </List>
      <Logout drawerOpen={open} />
    </S.Drawer>
  );

  return <>{getDesktopSidebar()}</>;
};

export default Sidebar;
